import { defineMessages, useIntl } from "react-intl";

import { changeComposeScheduledAt } from "flavours/glitch/actions/compose";
import { IconButton } from "flavours/glitch/components/icon_button";
import { useAppDispatch, useAppSelector } from "flavours/glitch/store";
import { isoToLocalInput, localInputToIso } from "flavours/glitch/utils/scheduled_at";

const messages = defineMessages({
  label: { id: "compose.schedule.label", defaultMessage: "Publish on" },
  remove: { id: "compose.unschedule", defaultMessage: "Post now instead of scheduling" },
});

// Date and time picker shown under the compose buttons while a post is scheduled.
const ScheduleRow = () => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const scheduledAt = useAppSelector(state => state.getIn(["compose", "scheduled_at"]));

  const handleChange = ({ target: { value } }) => {
    const iso = localInputToIso(value);

    if (iso) {
      dispatch(changeComposeScheduledAt(iso));
    }
  };

  const handleRemove = () => {
    dispatch(changeComposeScheduledAt(null));
  };

  return (
    <div className='compose-form__schedule'>
      <label className='compose-form__schedule-label'>
        <span>{intl.formatMessage(messages.label)}</span>
        <input
          type='datetime-local'
          value={isoToLocalInput(scheduledAt)}
          min={isoToLocalInput(new Date().toISOString())}
          onChange={handleChange}
        />
      </label>
      <IconButton icon='x' title={intl.formatMessage(messages.remove)} onClick={handleRemove} size={16} />
    </div>
  );
};

export default ScheduleRow;
